import { render, staticRenderFns } from "./VMonthDays.vue?vue&type=template&id=10d92e57"
import script from "./VMonthDays.vue?vue&type=script&lang=js"
export * from "./VMonthDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports